import axiosInstance from '../api/axios';


// Function to get all students
export const getAllStudents = async () => {
    try {
        const response = await axiosInstance.get('/students');
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const getAllTermStudents = async () => {
    try {
        const response = await axiosInstance.get('/getStudentTerms');
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};
export const getStudentById = async (id) => {
    try {
        const response = await axiosInstance.get(`/studentById?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const getStudentCourses = async (id) => {
    try {
        const response = await axiosInstance.get(`/getStudentCoursesById?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const getNoStudentCourses = async (id) => {
    try {
        const response = await axiosInstance.get(`/getNoStudentCourses?id=${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const getBatches = async () => {
    try {
        const response = await axiosInstance.get('/studentbatches');
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};
export const getAllBatchStudents = async (batch) => {
    try {
        const response = await axiosInstance.get(`/students?batch=${batch}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const getAllBatchTermStudents = async (batch,termId) => {
    try {
        const response = await axiosInstance.get(`/students?batch=${batch}&termId=${termId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

export const addNewCourse = async (studentcourse) => {
    try {
        const response = await axiosInstance.post(`/addStudentCourse`,studentcourse,{showToastOnResponse: true});
        return response.data;
    } catch (error) {
        console.error('Error fetching courses:', error);
        throw error;
    }
};
export const getAllBatchAndReportTypeStudents = async (batch,reportType) => {
    try {
        const response = await axiosInstance.get(`/studentsByBatchAndReportType?batch=${batch}&reportType=${reportType}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching students:', error);
        throw error;
    }
};

